<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Faktury'" [name]="'Lista plików do banku'"></app-breadcrumb>
<div class="bank-files-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="bank-files-list-filters">

    <app-datepicker
      class="bank-files-list-filter"
      label="Data generowania od "
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="bank-files-list-filter"
      label="Data generowania do "
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>
  </form>

  <div class="bank-files-list-buttons">
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="bankFiles">

    <!-- Position Column -->


    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data generowania</th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd H:mm:ss'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma</th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        {{element.user?.username }}
      </td>
    </ng-container>

    <ng-container matColumnDef="numberOfFiles">
      <th mat-header-cell *matHeaderCellDef> Liczba rekordów </th>
      <td mat-cell *matCellDef="let element">
        {{element.numberOfFiles}}
      </td>
    </ng-container>

    <ng-container matColumnDef="download">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">

          <button [disabled]="!(userPermissions | async).settlement.admin_root " (click)="download(element.uuid)"  mat-stroked-button color="accent"><mat-icon>download</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button [disabled]="!(userPermissions | async).settlement.admin_root "  (click)="delete(element.uuid)" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> </button>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
